import ImagesGridView from "components/base/ImagesGridView";

const BaseInfoView = ({ values }) => {
  return (
    <div className="card">
      <h5>Basic Info</h5>
      {values ? (
        <div className="mt-2 -mx-2">
          <table>
            <tbody>
              <tr className="border-y border-gray-100">
                <td>
                  <label>Contact Person (联系人/职位):</label>
                </td>
                <td className="w-full">{values.contactPerson || "-"}</td>
              </tr>
              <tr className="border-y border-gray-100">
                <td>
                  <label>Tel (电话):</label>
                </td>
                <td className="w-full">{values.tel || "-"}</td>
              </tr>
              <tr className="border-y border-gray-100">
                <td>
                  <label>Address (联系地址):</label>
                </td>
                <td className="w-full whitespace-pre-wrap">
                  {values.address || "-"}
                </td>
              </tr>

              <tr className="">
                <td className="pt-6">
                  <label className="text-sm opacity-100">
                    Introduction 公司介绍
                  </label>
                </td>
              </tr>

              <tr className="border-y border-gray-100">
                <td>
                  <label>Number of Employees (员工数量):</label>
                </td>
                <td className="w-full">{values.numberOfEmployees || "-"}</td>
              </tr>
              <tr className="border-y border-gray-100">
                <td>
                  <label>Year of Established (成立年份):</label>
                </td>
                <td className="w-full">{values.yearOfEstablished || "-"}</td>
              </tr>
              <tr className="border-y border-gray-100">
                <td>
                  <label>Major Products (主要产品):</label>
                </td>
                <td className="w-full">{values.majorProducts || "-"}</td>
              </tr>
              <tr className="border-y border-gray-100">
                <td>
                  <label>Equipment and Facilities (设备与设施):</label>
                </td>
                <td className="w-full">
                  {values.equipmentAndFacilities || "-"}
                </td>
              </tr>
              <tr className="border-y border-gray-100">
                <td>
                  <label>Major Market (主要市场):</label>
                </td>
                <td className="w-full">{values.majorMarket || "-"}</td>
              </tr>
              <tr className="border-y border-gray-100 align-top">
                <td>
                  <label>Photos (照片):</label>
                </td>
                <td className="w-full">
                  <ImagesGridView
                    previewTitle="Supplier Photos"
                    images={(Array.isArray(values.photos)
                      ? values.photos
                      : []
                    ).map((url, idx) => ({ url, name: `photo-${idx}` }))}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className="opacity-70 mt-2">
          Supplier has not submit anything yet.
        </div>
      )}
    </div>
  );
};

export default BaseInfoView;
